export default "__VITE_ASSET__DJaKkzbn__"